import list from 'src/modules/benchmarking/list/benchmarkingListReducers';
import { combineReducers } from 'redux';

export default combineReducers({
  list,
});
